import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-close-02',
	templateUrl: './icon-close-02.component.svg',
})
export class IconClose02Component {}
